'use client';

import { useEffect, useRef } from 'react';

/**
 * Подхватывает текст, набранный до гидратации.
 *
 * Поле ввода управляемое, поэтому всё, что человек успел напечатать, пока
 * грузился JavaScript, React при первом же рендере затирает: он ставит
 * значение из состояния, а состояние пустое. На быстрой машине этого не
 * видно, на медленной сети теряется первая фраза, и человек не понимает,
 * почему.
 *
 * Здесь мы делаем обратное: при монтировании смотрим, что уже лежит в DOM,
 * и переносим это в состояние.
 */
export function useAdoptPrefilledValue(
  ref: React.RefObject<HTMLTextAreaElement | null>,
  value: string,
  onChange: (value: string) => void,
) {
  // Эффект должен отработать ровно один раз, при первом появлении поля.
  const adopted = useRef(false);

  useEffect(() => {
    if (adopted.current) return;
    adopted.current = true;

    const current = ref.current?.value ?? '';
    if (current && current !== value) onChange(current);
  }, [ref, value, onChange]);
}
